module.exports = {"name":"Floor","component":"Floor","clauses":{"filter":{"en":"Filter Life","jp":"フィルター寿命"},"temp":{"en":"Temperature","jp":"温度"},"hum":{"en":"Humidity","jp":"湿度"},"iaq":{"en":"IAQ","jp":"IAQ"},"voc":{"en":"tVOC","jp":"tVOC"},"co2":{"en":"CO2","jp":"二酸化炭素"},"add":{"en":"Add Room","jp":"部屋の追加"},"cards":{"en":"Cards","jp":"カード"},"fractal":{"en":"Fractal","jp":"フラクタル"},"days":{"en":"Days","jp":"日数"},"day":{"en":"Day","jp":"日"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/langTemplates/FloorTemplate.json
// module id = 34
// module chunks = 1